export default __webpack_public_path__ + "static/media/plus_reading_glasses.d1f315b6.png";